import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/Auth/useAuth";

interface RequireAuthProps {
  children: React.ReactNode;
}

export default function RequireAuth({ children }: RequireAuthProps) {
  // const { isAuthenticated } = useAuth();
  // const { pathname, search } = useLocation();

  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // if (!isAuthenticated) {
  //   const searchParams = new URLSearchParams(search);

    // searchParams.set("redirect", pathname);

    // return <Navigate to={`/login?${searchParams.toString()}`} replace />;
  // }

  return children;
}
